var isUndefined = function (value) {
    return value === undefined;
};
export default isUndefined;
//# sourceMappingURL=is-undefined.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-undefined.js
// module id = 501
// module chunks = 3